import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { PropType } from 'vue'
import { CableVessel } from '@/server/MakeSenseApp-backend'
import { degreesToRadians, getVesselIcon } from '@/utilities/vesselMappings'


export default /*@__PURE__*/_defineComponent({
  __name: 'Vessels',
  props: {
  vesselData: {
    type: Array as PropType<CableVessel[]>,
    required: true
  },
  isVisible: {
    type: Boolean,
    required: true
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_ol_geom_point = _resolveComponent("ol-geom-point")!
  const _component_ol_style_icon = _resolveComponent("ol-style-icon")!
  const _component_ol_style = _resolveComponent("ol-style")!
  const _component_ol_feature = _resolveComponent("ol-feature")!
  const _component_ol_source_vector = _resolveComponent("ol-source-vector")!
  const _component_ol_vector_layer = _resolveComponent("ol-vector-layer")!

  return (_openBlock(), _createBlock(_component_ol_vector_layer, {
    zIndex: "15",
    visible: __props.isVisible
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ol_source_vector, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.vesselData, (vessel, index) => {
            return (_openBlock(), _createBlock(_component_ol_feature, {
              key: index,
              properties: { name: vessel.mmsi, type: 'vessel' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ol_geom_point, {
                  coordinates: [vessel.easting, vessel.northing]
                }, null, 8, ["coordinates"]),
                _createVNode(_component_ol_style, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ol_style_icon, {
                      src: _unref(getVesselIcon)(vessel),
                      width: 18,
                      height: 20,
                      rotateWithView: true,
                      rotation: _unref(degreesToRadians)(vessel.angle ?? 0)
                    }, null, 8, ["src", "rotation"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["properties"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})